import React from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { TodoAssigneesPopover } from "./TodoAssigneesPopover";
import { useTodoCreateState } from "@/src/features/TodoCreate/TodoCreateState";
import { TodoCreateAssigneesPopoverQuery } from "./__generated__/TodoCreateAssigneesPopoverQuery.graphql";

type TodoCreateAssigneesPopoverProps = {
  visible: boolean;
  onClose: () => void;
  fetchKey: string;
};

export function TodoCreateAssigneesPopover(
  props: TodoCreateAssigneesPopoverProps
) {
  const { state, setState } = useTodoCreateState();
  const teamIds = state.teamIds;
  const employeeIds = state.employeeIds;
  const roleIds = state.roleIds;
  const data = useLazyLoadQuery<TodoCreateAssigneesPopoverQuery>(
    graphql`
      query TodoCreateAssigneesPopoverQuery($teamIds: [ID!]) {
        store @required(action: THROW) {
          myRole
          employees(teamIds: $teamIds, sortByWorkingStatus: true) {
            ...TodoAssigneesPopover_EmployeeConnection
            edges {
              node {
                ...ToolbarButtonAssignees_employees
              }
            }
          }
          employeeRoles(teamIds: $teamIds) {
            ...TodoAssigneesPopover_Roles
            ...ToolbarButtonAssignees_roles
          }
        }
      }
    `,
    {
      teamIds: teamIds,
    },
    {
      fetchPolicy: "store-and-network",
      fetchKey: props.fetchKey,
    }
  );

  return (
    <TodoAssigneesPopover
      key={props.visible ? "visible" : "hidden"}
      employeeConnection={data.store.employees}
      visible={props.visible}
      onClose={props.onClose}
      assignEmployeeIds={employeeIds}
      setAssignEmployeeIds={(selectedAssigneeIds) => {
        setState((prev) => ({
          ...prev,
          employeeIds: selectedAssigneeIds,
        }));
      }}
      assignRoleIds={roleIds}
      setAssignRoleIds={(selectedRoleIds) => {
        setState((prev) => ({
          ...prev,
          roleIds: selectedRoleIds,
        }));
      }}
      roles={data.store.employeeRoles}
    />
  );
}
